<template>
	<div class="width-100 display-flex flex-column">
		<template v-if="!noSwitch">
			<MaybeUpgradeRequiredIndicator v-if="billingFeatureId" :billingFeatureId="billingFeatureId">
				<template #default="{ indicator, isUpgradeRequired }">
					<SwitchWithIndicatorSlot
						class="width-100"
						:title="title"
						:description="description"
						:disabled="isSwitchDisabled || isUpgradeRequired"
						v-model="switchModelLocal"
					>
						<template #indicator>
							<component class="ml-2" :is="indicator" :billingFeatureId="billingFeatureId" canBuild iconOnly v-if="isUpgradeRequired" />
						</template>
					</SwitchWithIndicatorSlot>
				</template>
			</MaybeUpgradeRequiredIndicator>
			<SwitchWithIndicatorSlot
				v-else
				class="width-100"
				:title="title"
				:description="description"
				:disabled="isSwitchDisabled"
				v-model="switchModelLocal"
			/>
		</template>
		<BasicTextField class="mb-5" v-if="showTextInput" :placeholder="placeholder" v-model="textFieldValueLocal" small />
	</div>
</template>
<script>
import debounce from 'lodash/debounce';

import SwitchWithIndicatorSlot from './SwitchWithIndicatorSlot.vue';
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
export default {
	name: 'SettingSwitch',
	props: {
		title: { type: String },
		noSwitch: { type: Boolean },
		description: { type: String },
		placeholder: { type: String },
		switchValue: { type: Boolean },
		textFieldValue: { type: String },
		isSwitchDisabled: { type: Boolean },
		billingFeatureId: { type: String },
	},
	components: { MaybeUpgradeRequiredIndicator, SwitchWithIndicatorSlot },
	computed: {
		showTextInput() {
			if (this.noSwitch) {
				return true;
			}
			return this.switchModelLocal && this.textFieldValue !== undefined;
		},
		switchModelLocal: {
			get() {
				return this.switchValue;
			},
			set(value) {
				this.$emit('update:switchValue', value);
			},
		},
		textFieldValueLocal: {
			get() {
				return this.textFieldValue;
			},
			set: debounce(function (value) {
				this.$emit('update:textFieldValue', value);
			}, 500),
		},
	},
};
</script>
<style scoped lang="scss"></style>
